import * as React from 'react';
import { createElement } from 'react';
import { Tabs } from 'antd';
export const ArrayTabsPreview = (props) => {
    const { fieldProps, componentProps } = props;
    const badgedTab = (index) => {
        const tab = `${fieldProps.title || 'Untitled'} ${index + 1}`;
        return tab;
    };
    return (createElement(React.Fragment, null,
        createElement(Tabs, Object.assign({ type: "editable-card" }, componentProps?.['x-component-props']),
            createElement(Tabs.TabPane, { key: "0", tab: badgedTab(0) }, props.children))));
};
